module.exports = __webpack_public_path__ + "static/img/newsLogo.78fa3786.png";